import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbAlertModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { CampaignService } from 'src/app/_services/campaign.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from 'src/app/directives/click-outside.directive';
import { CandidateService } from 'src/app/_services/candidate.service';
import { Router } from '@angular/router';
declare const clevertap;

@Component({
  selector: 'app-add-to-campaign',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ClickOutsideDirective, NgbAlertModule ],
  templateUrl: './add-to-campaign.component.html',
    styleUrls: ['./add-to-campaign.component.scss'],

})
export class AddToCampaignComponent {
  @Input() candidates: any[] = [];       // <-- the only thing that differs between single/bulk
  @Input() campaignList: any[] = [];
  @Output() campaignAdded = new EventEmitter<any>(); // let parent know (e.g. clear bulk selection)

  campaignSearch = new FormControl('');
  isDropdownOpen = false;
  filteredCampaigns: any[] = [];
  selectedCampaign: any = null;
  isLoadingEmailCampaignApi = false;
  emailFoundCount: number;
  successMessage = '';
  errorMessage = '';
  campaignName = '';
  @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
  @Input() calledFrom: string; // Input property to receive the source of the call
  isAddToEmailCampaignLoading: boolean = false;

  constructor(
    private emailCampaignService: CampaignService,
    private localstorageservice: LocalStorageService,
    private modalService: NgbModal,
    private candidateservice: CandidateService,
    private router: Router
  ) {}

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.campaignSearch.setValue('');
      this.filteredCampaigns = [...this.campaignList];
    }
  }

  ngOnInit() {
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  filterCampaigns() {
    this.filteredCampaigns = this.campaignList.filter(c =>
      c.campaign_name.toLowerCase().includes(this.campaignSearch.value.toLowerCase())
    );
  }

  async addToEmailCampaign(campaign) {
    this.isAddToEmailCampaignLoading = true;
    this.selectedCampaign = campaign;
    this.isDropdownOpen = false;
    this.isLoadingEmailCampaignApi = true;
    let totalTarget = 0;
    let unsubscribedCandidateCount = 0;

    const campaign_id = this.selectedCampaign.campaign_id;
    this.campaignName = this.selectedCampaign.campaign_name;

    // NOTE: this is the exact same block that used to live in the card,
    // just reading from `this.candidates` instead of `this.campaignCandidatesArray`
    let payloadArray = [];
    if(this.calledFrom === 'project-details-pipeline-view') {
     payloadArray = this.candidates.map(x => {
        totalTarget++;

        if (x?.basicdetails?.is_unsubscribed) {
          unsubscribedCandidateCount++;
          return;
        }

        let tempFirstName = x.basicdetails?.firstname || '';
        let tempLastName = x.basicdetails?.lastname || '';
        console.log('contact', x.contactdetails);
        console.log('tempFirstName', this.extractPreferredEmail(x.contactdetails));

        return {
          firstname: tempFirstName,
          target_name: tempFirstName + ' ' + tempLastName,
          target_id: x.candidateid,
          target_meta: JSON.stringify({
            candidatenumber: x.basicdetails.candidatenumber,
            title: x.basicdetails.jobtitle?.length
              ? x.basicdetails.jobtitle
              : x.pastexperience?.[0],
            elastic_id: x.basicdetails?.elastic_id || null,
          }),
          target_email: null,
          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString()
        };

    }).filter(Boolean);

      // if (!payloadArray.length) {
      //     this.closeActiveModal();
      //     this.toastmessage("Unsubscribed from Email Campaign", 'error');
      //     return;
      //   }

        const candidateNumbers = payloadArray.map((res) => JSON.parse(res.target_meta).candidatenumber);

        this.candidateservice.getBulkCandidateContactDetails(candidateNumbers).subscribe((resp: any) => {

          if (resp?.body?.status !== 'success') {
            this.toastmessage("Error fetching contact details", "error");
            this.closeActiveModal();
            return;
          }


          const bulkData = resp.body.data || {};

          payloadArray.forEach((payload) => {

            const existingEmails = bulkData[payload?.target_id]?.emails || [];
            let personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingEmails, 'personal');
            let professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingEmails, 'professional');

            let targetEmailFound = '';

            switch (this.selectedCampaign['email_pref']) {
              case 1:
                targetEmailFound = personalPref_email;
                break;
              case 2:
                targetEmailFound = professionalPref_email;
                break;
              case 3:
                targetEmailFound = personalPref_email || professionalPref_email;
                break;
              case 4:
                targetEmailFound = professionalPref_email || personalPref_email;
                break;
            }

            payload.target_email = targetEmailFound || null;
          });

          this.emailFoundCount = payloadArray.filter(x => x.target_email).length;
          this.campaignName = this.campaignName;

          this.emailCampaignService.createTarget(campaign_id, payloadArray).subscribe((res: any) => {
            this.isLoadingEmailCampaignApi = false;
            this.isAddToEmailCampaignLoading = false;
            this.closeActiveModal();

            if (res.status === 'success') {
                  if (res.data && res.data.length) {
                  const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
                  setTimeout(() => {
                    modalRef.close();
                  }, 5000);

                  //this.toastmessage("Candidate added to email campaign successfully", 'success');
                 //
                  /**
                   * add email campaign
                   */
                  const emailCampaignParams = {
                    "User ID": this.localstorageservice.getItem('userdata').userid,
                    "Candidate ID": this.selectedCampaign.toString(),
                    "Campaign Name": this.selectedCampaign.campaign_name
                  }
                  clevertap.event.push('Add Candidate to Email Campaign', emailCampaignParams);

                  if (payloadArray.length !== this.emailFoundCount){
                    // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                    const bulkRevealPayLoad = {
                      enrichedFrom: 'pipeline-listing',
                      candidates:[],
                      campaign_id: campaign_id
                    }

                    res.data.map((arr)=>{
                      if(!arr?.target_email){
                        bulkRevealPayLoad.candidates.push(
                          {
                            elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                            // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                            campaign_target_id: arr.campaign_target_id
                          }
                        );
                      }
                    });
                    const modalObj = {
                      calledFor:'email-campaign',
                      total_target: totalTarget,
                      campaignDetails: this.selectedCampaign,
                      emailsFound: this.emailFoundCount,
                      payload: bulkRevealPayLoad,
                      campaign_id: campaign_id,
                      unsubscribedCandidateCount: unsubscribedCandidateCount
                    }
          this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, totalTarget, unsubscribedCandidateCount);
                  }

                } else {
                this.closeActiveModal();
                if (unsubscribedCandidateCount) {
                  this.isAddToEmailCampaignLoading = false;
                  this.toastmessage("Unsubscribed from Email Campaign", 'error');
                } else {
                  this.toastmessage("Candidate already present in selected campaign", 'error');
                }
              };


            } else {
              this.closeActiveModal();
              this.toastmessage("Candidate addition failed", "error");
            }

          }, (error: HttpErrorResponse) => {
            this.isLoadingEmailCampaignApi = false;
            if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
              const remainingTargets = error.error.remainingTargets;
              this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
            } else {
              this.toastmessage("Something went wrong", "error");
            }
            this.closeActiveModal();
          });
        }, () => {
          this.toastmessage("Something went wrong", "error");
          this.closeActiveModal();
        });
    } else {
     payloadArray = this.candidates?.length && this.candidates.map(x => {
      totalTarget++;
      if (x?.is_unsubscribed) { unsubscribedCandidateCount++; return; }

      return {
        firstname: x.first_name,
        target_name: x.full_name,
        target_id: null,
        target_meta: JSON.stringify({
          candidatenumber: x.candidatenumber?.length ? x.candidatenumber : null,
          elastic_id: x.id,
          title: x.job_title,
        }),
        target_email: x.existingContactDetails?.length ? this.extractPreferredEmail(x.existingContactDetails) : null,
        is_active: true,
        created_on: new Date().toISOString(),
        updated_on: new Date().toISOString(),
      };

    }).filter(Boolean);


    const updatedPayloadArray = payloadArray?.length ? payloadArray.filter(x => x) : [];
    this.emailFoundCount = updatedPayloadArray.filter(x => x.target_email).length;

    const payloadWithCandidateNumber = updatedPayloadArray.filter(x => JSON.parse(x.target_meta || '{}')?.candidatenumber);
    const payloadWithoutCandidateNumber = updatedPayloadArray.filter(x => !JSON.parse(x.target_meta || '{}')?.candidatenumber);
    let finalPayload = payloadWithCandidateNumber;

    if (payloadWithoutCandidateNumber?.length) {
      const elasticid = payloadWithoutCandidateNumber.map(x => JSON.parse(x.target_meta).elastic_id);
      const res = await this.emailCampaignService.migrateCandidates({ elasticid }).toPromise();
      payloadWithoutCandidateNumber.forEach(x => {
        const parsedElasticId = JSON.parse(x.target_meta).elastic_id;
        const item = res?.data?.find(i => i.elasticId === parsedElasticId);
        if (item) {
          const tempMeta = JSON.parse(x.target_meta);
          tempMeta.candidatenumber = item.candidatenumber;
          x.target_meta = JSON.stringify(tempMeta);
        }
        x.target_id = null;
      });
      finalPayload = finalPayload.concat(payloadWithoutCandidateNumber);
    }
    finalPayload = finalPayload.filter(x => JSON.parse(x?.target_meta)?.candidatenumber);

    if (!finalPayload.length) {
      this.isLoadingEmailCampaignApi = false;
      this.errorMessage = "No valid email found for the candidate(s) based on the selected campaign's email preference";
      setTimeout(() => this.errorMessage = '', 5000);
      return;
    }

    if (unsubscribedCandidateCount > 0 && finalPayload.length === 0) {
      this.errorMessage = "Unsubscribed from Email Campaign";
      setTimeout(() => this.errorMessage = '', 5000);
      return;
    }

    this.emailCampaignService.createTarget(campaign_id, finalPayload).subscribe((res: any) => {
      this.isLoadingEmailCampaignApi = false;
      this.isAddToEmailCampaignLoading = false;
      if (res.status === 'success' && res.data?.length) {
        this.campaignName = this.selectedCampaign.campaign_name;
        const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass: 'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false });
        setTimeout(() => modalRef.close(), 5000);

        clevertap.event.push('Add Candidate to Email Campaign', {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Candidate ID": this.candidates.map(x => x.id).toString(),
          "Campaign Name": this.campaignSearch.value,
        });

        if (this.emailFoundCount !== finalPayload.length) {
          const bulkRevealPayLoad = { enrichedFrom: "person-search-listing", candidates: [], campaign_id };
          res.data.forEach(arr => {
            if (!arr?.target_email) {
              bulkRevealPayLoad.candidates.push({
                elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                campaign_target_id: arr.campaign_target_id,
              });
            }
          });
          this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, totalTarget, unsubscribedCandidateCount);
        }
        this.campaignAdded.emit({ campaign, candidates: this.candidates }); // parent can clear bulk selection here
      } else if(res.data.length === 0) {
        this.errorMessage = "Candidate already present in selected campaign";
        setTimeout(() => this.errorMessage = '', 5000);
      } else if (res.status === 'failure') {
        this.errorMessage = "Candidate addition failed";
        setTimeout(() => this.errorMessage = '', 5000);
      }
    }, (error: HttpErrorResponse) => {
      this.isLoadingEmailCampaignApi = false;
      this.errorMessage = (error.status === 400 && error.error?.remainingTargets)
        ? `Only ${error.error.remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`
        : "Something went wrong";
      setTimeout(() => this.errorMessage = '', 5000);
    });

    }

  }

  extractPreferredEmail(details) {

    const emailPref = this.selectedCampaign['email_pref'];
    const existingContactDetails = details?.emails?.existingDetails || details?.emails || details || [];

    let personalPref_email = '', professionalPref_email = '';
    if (existingContactDetails?.length) {
      personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal');
      professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional');
    }
    switch (emailPref) {
      case 1: return personalPref_email;
      case 2: return professionalPref_email;
      case 3: return personalPref_email || professionalPref_email;
      case 4: return professionalPref_email || personalPref_email;
      default: return '';
    }
  }

  openDetailsModal(campaign_id, payload, emailsFound, total_target, unsubscribedCandidateCount) {
    const modalRef = this.modalService.open(BulkRevealModalComponent, { windowClass: 'modalemailcampaign', size: 'xs' as 'lg', centered: true });
    Object.assign(modalRef.componentInstance, {
      campaign_id, payload, emailsFound,
      campaignDetails: this.selectedCampaign,
      total_target, unsubscribedCandidateCount,
      calledFor: 'email-campaign',
    });
  }


  // addToEmailCampaignPipeline(campaign) {
  //   this.isLoadingEmailCampaignApi = true;
  //       this.campaignSearch.markAllAsTouched();

  //       if (!this.campaignSearch.valid || !this.selectedCampaign) {
  //         this.isLoadingEmailCampaignApi = false;
  //         return;
  //       }

  //       let unsubscribedCandidateCount = 0;
  //       let totalTarget = 0;
  //       const campaign_id = this.selectedCampaign?.campaign_id;


  //       let payloadArray = this.candidates.map(x => {

  //           totalTarget++;

  //           if (x?.basicdetails?.is_unsubscribed) {
  //             unsubscribedCandidateCount++;
  //             return;
  //           }

  //           let tempFirstName = x.basicdetails?.firstname || '';
  //           let tempLastName = x.basicdetails?.lastname || '';

  //           return {
  //             firstname: tempFirstName,
  //             target_name: tempFirstName + ' ' + tempLastName,
  //             target_id: x.candidateid,
  //             target_meta: JSON.stringify({
  //               candidatenumber: x.basicdetails.candidatenumber,
  //               title: x.basicdetails.jobtitle?.length
  //                 ? x.basicdetails.jobtitle
  //                 : x.pastexperience?.[0],
  //               elastic_id: x.basicdetails?.elastic_id || null,
  //             }),
  //             target_email: null,
  //             is_active: true,
  //             created_on: new Date().toISOString(),
  //             updated_on: new Date().toISOString()
  //           };

  //       }).filter(Boolean);

  //       if (!payloadArray.length) {
  //         this.toastmessage("Unsubscribed from Email Campaign", 'error');
  //         return;
  //       }

  //       const candidateNumbers = payloadArray.map((res) => JSON.parse(res.target_meta).candidatenumber);

  //       this.candidateservice.getBulkCandidateContactDetails(candidateNumbers).subscribe((resp: any) => {

  //         if (resp?.body?.status !== 'success') {
  //           this.toastmessage("Error fetching contact details", "error");
  //           return;
  //         }


  //         const bulkData = resp.body.data || {};

  //         payloadArray.forEach((payload) => {

  //           const existingEmails = bulkData[payload?.target_id]?.emails || [];
  //           let personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingEmails, 'personal');
  //           let professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingEmails, 'professional');

  //           let targetEmailFound = '';

  //           switch (this.selectedCampaign['email_pref']) {
  //             case 1:
  //               targetEmailFound = personalPref_email;
  //               break;
  //             case 2:
  //               targetEmailFound = professionalPref_email;
  //               break;
  //             case 3:
  //               targetEmailFound = personalPref_email || professionalPref_email;
  //               break;
  //             case 4:
  //               targetEmailFound = professionalPref_email || personalPref_email;
  //               break;
  //           }

  //           payload.target_email = targetEmailFound || null;
  //         });

  //         this.emailFoundCount = payloadArray.filter(x => x.target_email).length;
  //         this.campaignName = this.campaignSearch.value;

  //         this.emailCampaignService.createTarget(campaign_id, payloadArray).subscribe((res: any) => {
  //           this.isLoadingEmailCampaignApi = false;

  //           if (res.status === 'success') {
  //                 if (res.data && res.data.length) {
  //                 const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
  //                 setTimeout(() => {
  //                   modalRef.close();
  //                 }, 5000);

  //                 //this.toastmessage("Candidate added to email campaign successfully", 'success');
  //                //
  //                 /**
  //                  * add email campaign
  //                  */
  //                 const emailCampaignParams = {
  //                   "User ID": this.localstorageservice.getItem('userdata').userid,
  //                   "Candidate ID": this.selectedcandidate.toString(),
  //                   "Campaign Name": this.selectedCampaign.campaign_name
  //                 }
  //                 clevertap.event.push('Add Candidate to Email Campaign', emailCampaignParams);

  //                 if (payloadArray.length !== this.emailFoundCount){
  //                   // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
  //                   const bulkRevealPayLoad = {
  //                     enrichedFrom: this.enrichedFromForReveal,
  //                     candidates:[],
  //                     campaign_id: campaign_id
  //                   }

  //                   res.data.map((arr)=>{
  //                     if(!arr?.target_email){
  //                       bulkRevealPayLoad.candidates.push(
  //                         {
  //                           elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
  //                           // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
  //                           campaign_target_id: arr.campaign_target_id
  //                         }
  //                       );
  //                     }
  //                   });
  //                   const modalObj = {
  //                     calledFor:'email-campaign',
  //                     total_target: totalTarget,
  //                     campaignDetails: this.selectedCampaign,
  //                     emailsFound: this.emailFoundCount,
  //                     payload: bulkRevealPayLoad,
  //                     campaign_id: campaign_id,
  //                     unsubscribedCandidateCount: unsubscribedCandidateCount
  //                   }
  //                  this.openDetailsModal(modalObj);
  //                 }

  //               } else {
  //               this.closeActiveModal();
  //               if (unsubscribedCandidateCount) {
  //                 this.toastmessage("Unsubscribed from Email Campaign", 'error');
  //               } else {
  //                 this.toastmessage("Candidate already present in selected campaign", 'error');
  //               }
  //             };

  //             this.selectedcandidate = [];
  //             this.candidatedetails.forEach((element, index) => {
  //               this.candidatedetails[index].selected = false;
  //             });
  //             this.selected = false;
  //           } else {
  //             this.closeActiveModal();
  //             this.toastmessage("Candidate addition failed", "error");
  //           }

  //         }, (error: HttpErrorResponse) => {
  //           this.isLoadingEmailCampaignApi = false;
  //           if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
  //             const remainingTargets = error.error.remainingTargets;
  //             this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
  //           } else {
  //             this.toastmessage("Something went wrong", "error");
  //           }
  //           this.closeActiveModal();
  //         });
  //       }, () => {
  //         this.toastmessage("Something went wrong", "error");
  //         this.closeActiveModal();
  //       });

  // }

    toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
}

  // openDetailsPipelineModal({ campaign_id, payload, emailsFound, total_target, calledFor, unsubscribedCandidateCount = 0, onTalentpoolLevel =  false }) {
  //   this.closeActiveModal();
  //   const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
  //   modalRef.componentInstance.campaign_id = campaign_id;
  //   modalRef.componentInstance.payload = payload;
  //   modalRef.componentInstance.emailsFound = emailsFound;
  //   modalRef.componentInstance.campaignDetails = this.selectedCampaign;
  //   modalRef.componentInstance.total_target = total_target;
  //   modalRef.componentInstance.calledFor = calledFor;
  //   modalRef.componentInstance.talentpoolSelectedCandidate = {data: this.selectedCandidateData, onTalentpoolLevel: onTalentpoolLevel};
  //   modalRef.componentInstance.unsubscribedCandidateCount = unsubscribedCandidateCount;
  //  // modalRef.componentInstance.bulkRevealType = this.bulkRevealType;

  //   modalRef.componentInstance.bulkRevealModalData.subscribe((res) => {
  //     if (res.status === 'success') {
  //       if (res?.data && res?.data?.candidates?.length) {
  //         this.bulkRevealBannerStatus(res.data.candidates);
  //       }
  //       this.bulkRevealBannerTalentpoolLevel.showBanner = false;
  //     }
  //     else if(res.status === 'failure'){
  //       this.toastmessage("Something went wrong", 'error');
  //     }
  //   });
  // }

  closeActiveModal() {
    this.modalService.dismissAll();
  }

  redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
    }
}
